export const PACKAGES_LOCAL_STORAGE_CACHE_KEY = 'axp-travel-search-flight-hotel/packages';
export const COMMON_LOCAL_STORAGE_CACHE_KEY = 'axp-consumer-travel/searchParameters';
